export default {
  state: {
    contestSeasons: [],
    contestId: '', // 选中的活动
    seasonList: [] // 活动下的活动季列表
  },
  mutations: {
    set_contestSeasons (state, val) {
      console.log(val, 'set_contestSeasons')
      state.contestId = val
      console.log(state, 'set_contestSeasonsstate')
    },
    set_contestId (state, val) {
      state.contestId = val
      console.log(state, 'set_contestSeasonsstate')
    },
    set_seasonList (state, val) {
      state.seasonList = val
      console.log(state, 'set_contestSeasonsstate')
    }
  },
  actions: {
    // async getActiveSample (context, val) {
    //   // console.log(vm.$api)
    //   let { commit } = context
    //   let { state } = context
    //   if (!state.activeSample) {
    //     console.log('我被触发了')
    //     setTimeout(() => {
    //       commit('set_activeSample', '完美啊，大兄弟')
    //     }, 1000)
    //   }
    // }
  }
}



// WEBPACK FOOTER //
// ./src/store/common.js